
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/build/[location]",
      function () {
        return require("private-next-pages/build/[location].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/build/[location]"])
      });
    }
  